export * from './update-notification-read-status.graphql';
